module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/nft5-75f35c6326f45b19ad2f5fbe229f8335.png";